import { InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export const PLAIN_HTTP_CLIENT = new InjectionToken<HttpClient>('PLAIN_HTTP_CLIENT');

